import React, { Component } from 'react'
import {
  NavBar,
  Icon,
  List
} from "antd-mobile";
import { connect } from "dva";
import moment from "moment";
import NoneDatas from "../../components/noneDatas";
import { formatTimeStamp } from "../../utils/common";

const Item = List.Item
const Brief = Item.Brief

@connect(({ admin }) => ({ admin }))
export class FuncDetail extends Component {
  state = {
    funcDetailList: []
  };
  componentDidMount() {
    const name = this.props.match.params.name;
    const id = this.props.match.params.id;
    const payload1 = {
      id: id
    }
    const payload2 = {
      uid: id
    }
    this.props.dispatch({
      type: name == "admin" ? "admin/getAdminJoinFunctions" : "admin/getUserJoinFunctions",
      payload: name == "admin" ? payload1 : payload2
    }).then(res => {
      if (res) {
        this.setState({
          funcDetailList: res.data,
        });
      }
    });
  }
  render() {
    const { funcDetailList } = this.state;
    return (
      <div className="adminFuncDetail">
        <NavBar
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >
          功能组详情
        </NavBar>
        <form>
          <List renderHeader={() => '到期信息'}>
            {
              funcDetailList.map((item, index) => (
                <Item multipleLine key={index} extra="到期时间">
                  {item.name} <Brief>{moment(item.deadline).format('YYYY-MM-DD')}</Brief>
                </Item>
              ))
            }
          </List>
          {funcDetailList.length == 0 ? <NoneDatas /> : ""}
        </form>
      </div>
    )
  }
}

export default FuncDetail
